import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { CreatorsListPage } from '@/features/creators';
import { formatDocumentTitle } from '@/lib/document-title';

/** Marketing › Creators — every creator's link, code and what they brought. */
export const Route = createFileRoute('/_auth/$orgId/marketing/creators')({
  component: CreatorsRoute,
});

function CreatorsRoute() {
  const { orgId } = Route.useParams();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Creators', 'Marketing')}</title>
      </Helmet>
      <CreatorsListPage routeOrgId={orgId} />
    </>
  );
}
